module.exports = __webpack_public_path__ + "static/media/programsettings.4b3bd099.svg";